<!-- 板材 -->
<template>
  <BaseFormItem
    class="board"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShowNewIcon="isShowNewIcon"
  >
    <div class="board__content">
      <el-table 
          v-loading="loading"
          class="board__table"
          size="mini"
          :data="list" 
          :row-class-name="({ row }) => isCheckedRow(row) ? 'isCheckedRow' : ''"
          @row-click="handleRowClick"
        >
          <el-table-column label="" width="40px">
            <div slot-scope="{ row }" class="board__table__radio">
              <!-- 选中 -->
              <img 
                v-if="isCheckedRow(row)" 
                src="@@/assets/img/icons/icon_checked.png" 
              />
              <span v-else></span>
            </div>
          </el-table-column>
          <el-table-column label="板材品牌" width="150px">
            <div slot-scope="{ row }">
              {{ row.board_brand.name }}
              <a 
                v-if="row.describe_pdf_url"
                class="board__table__pdf"
                target="_blank"
                :href="row.describe_pdf_url"
                @click.stop
              >
                <img src="@@/assets/img/icons/icon_pdf.png" />
              </a>
            </div>
          </el-table-column>
          <el-table-column label="型号" width="100px">
            <div slot-scope="{ row }">
              {{ row.board_model.name }}
            </div>
          </el-table-column>
          <el-table-column label="TG值" width="70px">
            <div slot-scope="{ row }">
              {{ row.board_tg.name }}
            </div>
          </el-table-column>
          <el-table-column label="阻燃性" width="70px">
            <div slot-scope="{ row }">
              {{ row.flame_retardancy.name }}
            </div>
          </el-table-column>
          <el-table-column label="指定板材费">
            <div slot-scope="{ row }">
              {{ row.specific_fee.name }}
            </div>
          </el-table-column>
        </el-table>
    </div>
  </BaseFormItem>
</template>

<script>
import { debounce } from 'throttle-debounce'
import { getFR4Fields } from '@@/utils/getFields'
import { alertFieldsTips } from '@@/utils/alertFieldsTips'
import { getBoardList } from '@@/api/pcb'

export default {
  props: {
    // 板材品牌
    board_brand: {
      type: String,
      default: ''
    },
    // TG值
    board_tg: {
      type: String,
      default: ''
    },
    // 型号
    board_model: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: () => ({})
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      val: {
        board_brand: this.board_brand,
        board_tg: this.board_tg,
        board_model: this.board_model
      },
      list: [],
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      debounceGetList: debounce(800, this.getList)
    }
  },
  computed: {
    fields() {
      return getFR4Fields('board')
    },
    // 是否显示 NEW 标识
    isShowNewIcon() {
      return new Date().getTime() <= new Date('2025-08-10').getTime()
    }
  },
  watch: {
    board_brand(board_brand) {
      this.val.board_brand = board_brand
    },
    board_tg(board_tg) {
      this.val.board_tg = board_tg
    },
    board_model(board_model) {
      this.val.board_model = board_model
    },
    params(newVal, oldVal) {
      // 默认值：newVal.blayer === 2 && newVal.blind === 0
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal) || (newVal.blayer === 2 && newVal.blind === 0 && !this.list.length)) {
        this.debounceGetList()
      }
    }
  },
  mounted() {
    let { id } = this.$route.query
    if (!id) {
      this.getList()
    } else {
      this.loading = true
    }
  },
  methods: {
    handleEmit() {
      for (let [key, value] of Object.entries(this.val)) {
        this.$emit(`update:${key}`, value)
      }
    },
    handleRowClick(row) {
      const { board_brand = {}, board_tg = {}, board_model = {} } = row || {}
      this.val.board_brand = board_brand.value || ''
      this.val.board_tg = board_tg.value || ''
      this.val.board_model = board_model.value || ''
      this.handleEmit()
      this.$emit('change', { ...this.val })
      this.isShowError(false)
    },
    getList() {
      this.loading = true
      getBoardList(this.params)
        .then(res => {
          if (!res) return
          this.list = res.data || []
          this.handleListChange()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 当前选中行
    isCheckedRow(row) {
      const val = this.val
      return `${val.board_brand}_${val.board_tg}` === `${row.board_brand.value}_${row.board_tg.value}`
    },
    // 列表改变时，判断列表中是否存在当前选中的选项
    handleListChange() {
      if (this.initPcbParamsChange) return
      const { val, list, fields } = this
      if (list.length) {
        const hasItem = list.some(this.isCheckedRow)
        // 当前选中的选项不在列表中时
        if (!hasItem) {
          // if (val.board_brand && val.board_tg) {
          //   alertFieldsTips(fields.label)
          // }
          // 获取默认选项
          const defaultItem = list.find(i => i.is_checked)
          this.handleRowClick(defaultItem)
        }
      }
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
.board__content {
  box-sizing: border-box;
  padding: 6px 12px;
  width: 600px;
  border-radius: 3px;
  border: 1px solid #d7d7d7;
}
.board__table {
  font-size: 13px;
  &::before {
    display: none;
  }
  ::v-deep {
    .el-table__cell {
      padding: 3px 0;
    }
    .cell {
      padding-left: 0;
      padding-right: 0;
    }
    .el-table__header {
      margin-bottom: 6px;
      th.el-table__cell {
        padding-top: 0;
        line-height: 28px;
        &:first-child {
          border-bottom: none;
        }
        .cell {
          padding-left: 0;
        }
      }
    }
    .el-table__body {
      tr {
        cursor: pointer;
        td {
          &.el-table__cell {
            border-top: 1px solid transparent;
            border-bottom: 1px solid transparent;
            &:first-child {
              border-left: 1px solid transparent;
              border-top-left-radius: $--border-radius-base;
              border-bottom-left-radius: $--border-radius-base;
            }
            &:last-child {
              border-right: 1px solid transparent;
              border-top-right-radius: $--border-radius-base;
              border-bottom-right-radius: $--border-radius-base;
            }
          }
        }
        &.isCheckedRow {
          td.el-table__cell {
            border-color: $--form-color-base;
          }
        }
        &.isCheckedRow,
        &:hover>td.el-table__cell {
          color: $--form-color-base;
          background-color: $--radio-checked-background-color;
        }
      }
    }
  }
  .board__table__radio {
    display: flex;
    justify-content: center;
    align-items: center;
    >span {
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 1px solid #d7d7d7;
    }
    >img {
      display: block;
      width: 16px;
      height: 16px;
    }
  }
  .board__table__pdf {
    img {
      vertical-align: text-top;
    }
  }
}
</style>